import { FC } from 'react';
import { Icon } from 'learning-panel-components';
import styles from './undoPopup.module.scss';

const UndoPopup: FC<UndoPopupProps> = (props: UndoPopupProps) => {
    const { undoData, uuid, containerStyle = {} } = props;

    return (
        <div className={styles['undo-wrapper']} style={containerStyle}>
            <span className={styles['undo-wrapper-title']}>{undoData[uuid].title}</span>
            <div className={styles['undo-action']} onClick={() => undoData[uuid].callback()}>
                <Icon name={undoData[uuid].isUndo ? 'revertPink' : 'retryPink'} style={{ display: 'flex' }} />
                <span style={{ marginLeft: '0.4rem' }}>{undoData[uuid].callbackTitle}</span>
            </div>
        </div>
    );
};

interface UndoPopupProps {
    undoData: any;
    uuid: string;
    containerStyle?: object;
}

export default UndoPopup;
